import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Card, CardContent, Heading, Notice, Separator } from 'telia-front-react';
import RoamingStore from '../../stores/RoamingStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Segment } from '../../stores/SegmentStore';
import RoamingPackages from '../packages/RoamingPackages';

interface NonEeaCountryCardProps {
  segment: Segment;
  showAutoDayPackageInfo?: boolean;
  roamingStore?: RoamingStore;
}

@observer
class NonEeaCountryCard extends React.Component<NonEeaCountryCardProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const {
      segment,
      showAutoDayPackageInfo,
      roamingStore: { packageList },
    } = this.props;
    if (!packageList.packages || !packageList.packages.length) {
      return null;
    }

    return (
      <Card padding="small" responsive={[{ breakPoint: 'md', props: { padding: 'xlarge' } }]} type="light" background="neutral-bg-level-1">
        <CardContent>
          <Heading element="h2">{translate('roaming.country.non-eea.packages.header')}</Heading>
          <Separator spacing="small" color="invisible" />
          <RoamingPackages segment={segment} />
          <Separator spacing="small" color="invisible" />
          {showAutoDayPackageInfo && (
            <>
              <Notice size="small">
                <p>{translate('roaming.country.non-eea.notice.text')}</p>
              </Notice>
              <Separator spacing="xxsmall" color="invisible" />
              <Notice size="small" type="attention">
                <p>{translate('roaming.country.non-eea.notice.dataswitch.text')}</p>
              </Notice>
            </>
          )}
        </CardContent>
      </Card>
    );
  }
}

export default inject('roamingStore')(NonEeaCountryCard);
